type DiscountFailureMap<R> = {
  serverFailure: () => R;
  networkFailure: () => R;
};

type DiscountFailureMaybeMap<R> = {
  serverFailure?: () => R;
  networkFailure?: () => R;
  orElse: () => R;
};

abstract class _DiscountFailure extends Error {
  public abstract map<R>(callbacks: DiscountFailureMap<R>): R;
  public abstract maybeMap<R>(callbacks: DiscountFailureMaybeMap<R>): R;
}

class ServerFailure extends _DiscountFailure {
  constructor() {
    super("ServerFailure");
  }

  public map<R>(callbacks: DiscountFailureMap<R>): R {
    return callbacks.serverFailure();
  }

  public maybeMap<R>(callbacks: DiscountFailureMaybeMap<R>): R {
    if (callbacks.serverFailure) return callbacks.serverFailure();
    return callbacks.orElse();
  }
}

class NetworkFailure extends _DiscountFailure {
  constructor() {
    super("NetworkFailure");
  }

  public map<R>(callbacks: DiscountFailureMap<R>): R {
    return callbacks.networkFailure();
  }

  public maybeMap<R>(callbacks: DiscountFailureMaybeMap<R>): R {
    if (callbacks.networkFailure) return callbacks.networkFailure();
    return callbacks.orElse();
  }
}

export type DiscountFailure = ServerFailure | NetworkFailure;

export const DiscountFailure = {
  serverFailure: () => new ServerFailure(),
  networkFailure: () => new NetworkFailure(),
};
